import _classCallCheck from "D:\\a\\1\\s\\Ktm.Configurator.Web\\ClientApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\a\\1\\s\\Ktm.Configurator.Web\\ClientApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
export var Sdp =
/*#__PURE__*/
function () {
  function Sdp() {
    _classCallCheck(this, Sdp);
  }

  _createClass(Sdp, null, [{
    key: "getVideoCodecIds",
    value: function getVideoCodecIds(lines) {
      var videoLine = lines.filter(function (line) {
        return line.startsWith('m=video');
      })[0];
      return videoLine.split(' ').slice(3);
    }
  }, {
    key: "getAudioCodecIds",
    value: function getAudioCodecIds(lines) {
      var audioLines = lines.filter(function (line) {
        return line.startsWith('m=audio');
      });

      if (audioLines.length === 0) {
        return [];
      }

      var audioLine = audioLines[0];
      return audioLine.split(' ').slice(3);
    }
  }, {
    key: "mapVideoLine",
    value: function mapVideoLine(line, codecIds) {
      if (!line.startsWith('m=video')) {
        return line;
      }

      var videoLine = line.split(' ').slice(0, 3).join(' ');
      videoLine += ' ' + codecIds.join(' ');
      return videoLine;
    }
  }, {
    key: "mapAudioLine",
    value: function mapAudioLine(line, codecIds) {
      if (!line.startsWith('m=audio')) {
        return line;
      }

      var videoLine = line.split(' ').slice(0, 3).join(' ');
      videoLine += ' ' + codecIds.join(' ');
      return videoLine;
    }
  }, {
    key: "isVideoCodecH264",
    value: function isVideoCodecH264(lines, codecId) {
      var _this = this;

      var codecLines = lines.filter(function (line) {
        return _this.belongsToCodec(line, codecId);
      });
      var mapLine = codecLines.filter(function (line) {
        return line.startsWith('a=rtpmap');
      })[0];
      if (!mapLine) return false;
      var codecType = mapLine.split(' ')[1].split('/')[0];

      if (codecType !== 'H264') {
        return false;
      }

      var mapLine2 = codecLines.filter(function (line) {
        return line.startsWith('a=fmtp');
      })[0];
      if (!mapLine2) return false;
      var profileLevelId = this.getProfileLevelId(mapLine2);
      return !(profileLevelId !== '42e01f' && profileLevelId != '42001f');
    }
  }, {
    key: "isAudioCodecOpus",
    value: function isAudioCodecOpus(lines, codecId) {
      var _this2 = this;

      var codecLines = lines.filter(function (line) {
        return _this2.belongsToCodec(line, codecId);
      });
      var mapLine = codecLines.filter(function (line) {
        return line.startsWith('a=rtpmap');
      })[0];
      if (!mapLine) return false;
      var codecType = mapLine.split(' ')[1].split('/')[0];
      return codecType === 'opus';
    }
  }, {
    key: "forceH264",
    value: function forceH264(sdp, start, min, max) {
      var _this3 = this;

      var lines = sdp.split(/\r?\n/);
      var codecIds = this.getVideoCodecIds(lines);
      var matches = [];
      codecIds.forEach(function (codecId) {
        if (!_this3.isVideoCodecH264(lines, codecId)) {
          lines = lines.filter(function (line) {
            return !_this3.belongsToCodec(line, codecId);
          });
        } else {
          matches.push(codecId);
        }
      });
      if (matches.length === 0) throw new Error('your device does not support streaming');
      matches.forEach(function (codecId) {
        var lastCodecIndex = _this3.getLastCodecIndex(lines, codecId);

        if (isNaN(lastCodecIndex)) return;
        lines.splice(lastCodecIndex + 1, 0, "a=fmtp:".concat(codecId, " x-google-max-bitrate=").concat(max));
        lines.splice(lastCodecIndex + 2, 0, "a=fmtp:".concat(codecId, " x-google-min-bitrate=").concat(min));
        lines.splice(lastCodecIndex + 3, 0, "a=fmtp:".concat(codecId, " x-google-start-bitrate=").concat(start));
      });
      lines = lines.map(function (line) {
        return _this3.mapVideoLine(line, matches);
      });
      return lines.join('\n');
    }
  }, {
    key: "forceOpus",
    value: function forceOpus(sdp) {
      var _this4 = this;

      var lines = sdp.split(/\r?\n/);
      var codecIds = this.getAudioCodecIds(lines);
      var matches = [];
      codecIds.forEach(function (codecId) {
        if (!_this4.isAudioCodecOpus(lines, codecId)) {
          lines = lines.filter(function (line) {
            return !_this4.belongsToCodec(line, codecId);
          });
        } else {
          matches.push(codecId);
        }
      });
      lines = lines.map(function (line) {
        return _this4.mapAudioLine(line, matches);
      });
      return lines.join('\n');
    }
  }, {
    key: "getLastCodecIndex",
    value: function getLastCodecIndex(lines, id) {
      for (var idx = 0; idx < lines.length; ++idx) {
        if (!this.belongsToCodec(lines[idx], id)) continue;
        return this.getNextNonCodecIndex(lines, idx, id);
      }

      return NaN;
    }
  }, {
    key: "getNextNonCodecIndex",
    value: function getNextNonCodecIndex(lines, idx, id) {
      while (idx + 1 < lines.length && this.belongsToCodec(lines[idx + 1], id)) {
        idx++;
      }

      return idx;
    }
  }, {
    key: "belongsToCodec",
    value: function belongsToCodec(line, id) {
      if (!line.startsWith('a=')) return false;
      return line.startsWith("a=fmtp:".concat(id, " ")) || line.startsWith("a=rtcp-fb:".concat(id, " ")) || line.startsWith("a=rtpmap:".concat(id, " "));
    }
  }, {
    key: "getProfileLevelId",
    value: function getProfileLevelId(line) {
      var index = line.indexOf('profile-level-id=');
      if (index === -1) return null;
      var plid = line.substring(index + 17);
      plid = plid.split(';')[0];
      return plid;
    }
  }]);

  return Sdp;
}();